import React from 'react';
import PropTypes from 'prop-types';
import COLORS from 'constants/colors';

import styled, { css } from 'styled-components';
import { FONT_FAMILY } from 'constants/font';
import { Text } from '@cuemath/comps';

const TextFont = styled(Text)`
  font-family: ${FONT_FAMILY};
`;

const Input = styled.input`
  width: 100%;
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};
  ${({ disabled }) =>
    disabled
      ? css`
      background-color: ${COLORS.BG_CLOUD}
      color: ${COLORS.DISABLED_TEXT}
    `
      : css`
      background-color: ${COLORS.WHITE}
      color: ${COLORS.COLA}
    `};
  height: 40px;
  color: ${COLORS.TEXT_PRIMARY};
  padding: 5px;
  font-size: 14px;
  border: none;
  border: 1px solid;
  border-radius: 4px;
  border-color: ${({ error }) => (error ? COLORS.RED : COLORS.BG_CLOUD)};
`;

const FeedbackInput = styled.textarea`
  box-sizing: border-box;
  height: 70px;
  width: calc(100% - 40px);
  border: 1.4px solid ${COLORS.SKY_XLIGHT};
  border-radius: 5.6px;
  background-color: ${COLORS.WHITE};
  margin: 0 20px;
  padding: 5px 10px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;

  &::placeholder {
    color: ${COLORS.NOBEL};
  }
`;

const getFeedbackInput = props => {
  const {
    name,
    type,
    label,
    onChange,
    placeholder,
    value,
    minValue,
    maxValue,
    disabled,
    ...other
  } = props;

  return (
    <FeedbackInput
      id={`id_${name}`}
      name={name}
      type={type}
      onChange={onChange}
      placeholder={placeholder}
      defaultValue={value}
      min={minValue}
      disabled={disabled}
      max={maxValue}
      {...other}
    />
  );
};

export default function TextInput(props) {
  const {
    name,
    type,
    label,
    onChange,
    placeholder,
    value,
    minValue,
    maxValue,
    disabled,
    feedbackType,
    ...other
  } = props;

  return (
    <div>
      {label && (
        <label htmlFor={`id_${name}`}>
          <TextFont size="small">{label}</TextFont>
        </label>
      )}
      {feedbackType === 'widget' ? (
        getFeedbackInput(props)
      ) : (
        <Input
          id={`id_${name}`}
          name={name}
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          defaultValue={value}
          min={minValue}
          disabled={disabled}
          max={maxValue}
          {...other}
        />
      )}
    </div>
  );
}
TextInput.defaultProps = {
  placeholder: '',
  label: null,
  error: null,
  minValue: null,
  maxValue: null,
  onChange: () => {},
  feedbackType: null,
};
TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  minValue: PropTypes.string,
  maxValue: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  feedbackType: PropTypes.string,
};
